import {Component, Input, OnInit} from '@angular/core';
import {AuthService} from '../../../auth/auth.service';
import {TranslateService} from '../../../shared/translate.service';
import {Router} from "@angular/router";

@Component({
  selector: 'app-nav-account-list',
  templateUrl: './nav-account-list.component.html',
  styleUrls: ['./nav-account-list.component.scss']
})
export class NavAccountListComponent implements OnInit{

  @Input() showAccount = false;

  @Input() mobile = false;

  isLogged = false;

  authUnavailable = false;

  constructor(private authService: AuthService, public translateService: TranslateService, private route: Router){}

  ngOnInit(): void {
    this.authService.isLogged.subscribe(value => {
      this.isLogged = value;
    });
    this.authService.authUnavailable.subscribe(value => {
      this.authUnavailable = value;
    });
  }

  login(){
    this.route.navigateByUrl('/login');
  }

  logout(){
    this.authService.logout();
  }

  register(){
    this.route.navigateByUrl('/register');
  }
}
